import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RegistrationCompleteView } from '@/components/pages/registration/RegistrationCompleteView';
/**
 * 新規登録完了
 * NOTE: ページ構成統一のため作成してあります。ページ内で使用されるロジック周りの処理はここに書いてください
 */
export const RegistrationCompletePage = () => _jsx(RegistrationCompleteView, {});
